import { saveAllRequests } from '../../../indexedDb/requests'
import { saveFleetData } from '../../../indexedDb/fleets'
import {
    getAllRequests,
    getPMRequests,
    getRequestsDetails,
} from '../repositories/RequestRepository'
import { saveAllPMWorkOrders } from '../../../indexedDb/pmWorkOrders'
import { saveRequestDetails } from '../../../indexedDb/requestsDetails'

export const cacheInitialData = async (
    userId,
    locPreferencesId,
    handleSearchFleet,
    fleetFilters,
    setIsFetching,
    setDataFetched,
) => {
    const filterInfo = {
        query: '',
        categories: fleetFilters,
        user: userId,
    }

    const onFilterSuccess = async response => {
        await saveFleetData(response?.data?.fleet)
    }

    const onFilterError = () => {
        saveFleetData([])
    }

    try {
        // Save Requests Data
        const apiRequestsData = await getAllRequests(locPreferencesId)
        const openRequests = apiRequestsData?.data?.openRequests

        const arrayRequestsIDs = openRequests
            ?.filter(request => request.id && request.showType === 'Repair')
            .map(request => request.id)

        await saveAllRequests(apiRequestsData)

        // Save Fleets Data
        handleSearchFleet(filterInfo, onFilterSuccess, onFilterError)

        // Save PM Work Orders
        const apiPMRequestsData = await getPMRequests(locPreferencesId)
        await saveAllPMWorkOrders(apiPMRequestsData)

        const cacheRequestsDetails = await getRequestsDetails(arrayRequestsIDs)
        await saveRequestDetails(cacheRequestsDetails?.data?.requestDetails)

        setIsFetching(false)
        setDataFetched(true)
    } catch (error) {
        console.error('Error caching initial data:', error)
        setIsFetching(false)
        setDataFetched(true)
    }
}
